import { Box, Card, CardContent, CardHeader, Typography, createStyles, makeStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        cardheader: {
            background: "linear-gradient(85deg, " + theme.palette.primary.light + ", " + theme.palette.primary.dark + ")",
            minHeight: 75,
            padding: theme.spacing(2, 4),
        },
        header: {
            color: theme.palette.common.white,
        },
        headerAddress: {
            fontSize: theme.typography.body2.fontSize,
            fontWeight: 300,
        },
        root: function () { return ({
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[3],
        }); },
    });
});
var getAddress = function (place) { return place.address + " - " + place.zipcode + " " + place.city.toUpperCase(); };
export default (function (_a) {
    var header = _a.header, place = _a.place, date = _a.date, children = _a.children;
    var cardStyle = useStyle({});
    moment.locale('fr');
    return (React.createElement(Card, { elevation: 5 },
        header && date && place && (React.createElement(CardHeader, { className: cardStyle.cardheader, title: React.createElement(Header, { date: date, place: place }) })),
        React.createElement(CardContent, { style: { padding: '32px 25px' } }, children)));
});
var Header = function (_a) {
    var place = _a.place, date = _a.date;
    var headerStyle = useStyle({});
    var parsedDate = moment(date);
    var address = getAddress(place);
    return (React.createElement(Box, { display: "flex", justifyContent: "space-between" },
        React.createElement(Box, { className: headerStyle.header },
            React.createElement(Typography, null, place.name),
            React.createElement(Typography, { className: headerStyle.headerAddress }, address)),
        React.createElement(Box, { className: headerStyle.header, textAlign: "center" },
            React.createElement(Typography, null, parsedDate.format('dddd DD MMMM')),
            React.createElement(Typography, { className: headerStyle.headerAddress }, parsedDate.format('HH:mm')))));
};
//# sourceMappingURL=index.js.map